import { render, staticRenderFns } from "./status-speed.vue?vue&type=template&id=20b43651&scoped=true&"
import script from "./status-speed.js?vue&type=script&lang=js&"
export * from "./status-speed.js?vue&type=script&lang=js&"
import style0 from "./status-speed.css?vue&type=style&index=0&id=20b43651&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b43651",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
